'use client';
import Image from 'next/image';

const speakers = [
  {
    name: "Ferhat Doğru",
    designation: "CEO",
    company: "Some Capital",
    imageSrc: "/images/speakers/ferhat-dogru.webp",
    alt: "ferhat-dogru",
  },
  {
    name: "Sergiu Vasilescu",
    designation: "Managing Partner",
    company: "VD Law Group",
    imageSrc: "/images/speakers/sergiu-vasilescu-new.webp",
    alt: "sergiu-vasilescu",
  },
  {
    name: "Yara Alatrach",
    designation: "Co-founder",
    company: "EDNAS Academy",
    imageSrc: "/images/speakers/yara-alatrach-new.webp",
    alt: "yara-alatrach-new",
  },
   {
    name: "Anton Mosharov",
    designation: " Founder",
    company: "OmegaCloud.ai",
    imageSrc: "/images/speakers/anton-mosharov.webp",
    alt: "anton-mosharov",
  },
  
  {
    name: "Ben Owen",
    designation: "Founder & CEO",
    company: "Atelic.ai",
    imageSrc: "/images/speakers/ben-owen.webp",
    alt: "ben-owen",
  },
  {
    name: "Anton Reshetov",
    designation: "Co-founder",
    company: "TheGarden | AI Salon Dubai",
    imageSrc: "/images/speakers/anton-reshetov.webp",
    alt: "anton-reshetov",
  },
  // past 2025 speakers
   {
    name: "May Ann Lim",
    designation: " Director",
    company: "Asia Cloud Computing Association",
    imageSrc: "/images/speakers/may-ann-lim.webp",
    alt: "may-ann-lim",
  },
  {
    name: "Victor R. Ocampo",
    designation: "Co-Chair, APAC special interest group",
    company: "Decentralised Identity Foundation",
    imageSrc: "/images/speakers/victor-r-ocampo.webp",
    alt: "victor-r",
  },
   {
    name: "Ethan Seow",
    designation: "CEO and co-founder",
    company: "Centre for AI Leadership (C4AIL)",
    imageSrc: "/images/speakers/ethan-seow.webp",
    alt: "ethan",
  },
   {
    name: "Preetam Rao",
    designation: "Co-founder",
    company: "Quill Audits",
    imageSrc: "/images/speakers/preetam.webp",
    alt: "preetam",
  },
  
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:82:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="82" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20bg-%5Blinear-gradient(360deg%2C%23060606_0%25%2C%23000000_70%25%2C_%23120049_100%25)%5D%20rounded-%5B6px%5D%20pt-%5B80px%5D%20pb-%5B80px%5D%20px-4%22%7D" id='speakers'
      className="w-full bg-[linear-gradient(360deg,#060606_0%,#000000_70%,_#120049_100%)] rounded-[6px] pt-[80px] pb-[80px] px-4"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:85:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="85" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20mx-auto%22%7D" className="w-full mx-auto">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.jsx:87:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="87" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22uppercase%20text-2xl%20sm%3Atext-3xl%20md%3Atext-4xl%20lg%3Atext-%5B28px%5D%20font-open-sans%20font-semibold%20leading-8%20sm%3Aleading-9%20md%3Aleading-10%20lg%3Aleading-%5B39px%5D%20text-center%20text-white%20mb-8%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="uppercase text-2xl sm:text-3xl md:text-4xl lg:text-[28px] font-open-sans font-semibold leading-8 sm:leading-9 md:leading-10 lg:leading-[39px] text-center text-white mb-8">
          Past Speakers
        </h2>

        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.jsx:92:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="92" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1230px%5D%20mx-auto%22%7D" className="w-full  max-w-[1230px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.jsx:94:10" data-component-path="src/app/SpeakerSection.jsx" data-component-line="94" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-5%20sm%3Agap-6%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.jsx:96:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="96" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakerSection.jsx:98:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="98" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image data-component-id="src/app/SpeakerSection.jsx:99:18" data-component-path="src/app/SpeakerSection.jsx" data-component-line="99" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%20w-%5B320px%5D%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    objectFit="cover"
                    height={200}
                    width={200}
                    className="rounded-full w-[320px]"
                    unoptimized
                  />
                </div>
                <h3 data-component-id="src/app/SpeakerSection.jsx:109:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="109" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23fff%5D%20text-%5B16px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#fff] text-[16px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.jsx:112:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="112" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-white text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.jsx:115:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="115" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-white text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
